var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2199_19047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89483 1C12.3159 1 14.3159 2.85 14.3159 5.2C14.3159 7.5 12.3685 9.4 9.89483 9.4C7.42115 9.4 5.47378 7.55 5.47378 5.2C5.47378 2.9 7.47378 1 9.89483 1ZM9.89483 0C6.89483 0 4.42114 2.3 4.42114 5.2C4.42114 8.05 6.8422 10.4 9.89483 10.4C12.9475 10.4 15.3685 8.1 15.3685 5.2C15.3685 2.35 12.8948 0 9.89483 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9474 11.2C16.8421 11.85 18.2632 13.45 18.6842 15.3C16.4211 17.65 13.2632 19 9.89474 19C6.52632 19 3.36842 17.65 1.10526 15.3C1.52632 13.4 2.94737 11.85 4.84211 11.2C6.05263 12.65 7.89474 13.5 9.89474 13.5C11.8947 13.5 13.7368 12.65 14.9474 11.2ZM14.5263 10C13.5789 11.5 11.8421 12.45 9.89474 12.45C7.94737 12.45 6.21053 11.45 5.26316 10C2.47368 10.65 0.368421 12.85 0 15.6C2.36842 18.3 5.94737 20 9.89474 20C13.8421 20 17.4211 18.3 19.7895 15.6C19.4211 12.85 17.3158 10.65 14.5263 10Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2199_19047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.01d35f42644f049f4315d7fa69aa6f0d.svg";
export { ForwardRef as ReactComponent };